import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  FETCH_JUSTIFICATION_DEMARCATE_LIST_REQUEST,
  FETCH_JUSTIFICATION_DEMARCATE_LIST_SUCCESS,
  FETCH_JUSTIFICATION_DEMARCATE_LIST_ERROR,
  UPDATE_JUSTIFICATION_DEMARCATE_REQUEST,
  UPDATE_JUSTIFICATION_DEMARCATE_SUCCESS,
  UPDATE_JUSTIFICATION_DEMARCATE_ERROR,
  GET_PAGES,
} from 'actionTypes'

const getPages = (metadata) => ({
  type: GET_PAGES,
  pages: metadata.pageCount,
  current: metadata.page,
  count: metadata.totalCount,
})

export const fetchJustificationDemarcateList =
  (token, page = 1) =>
  (dispatch) => {
    dispatch(fetchJustificationDemarcateListRequest())
    const param = {
      page,
    }

    return new Api(token, dispatch)
      .get(API_URL.LIST_JUSTIFICATION_DEMARCATE, param)
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(getPages(response.data.pagination))
        dispatch(
          fetchJustificationDemarcateListSuccess(response.data.listPresenter)
        )
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(fetchJustificationDemarcateListError(error))
        dispatch(hideSpinner())
      })
  }

export const fetchJustificationDemarcateListRequest = () => ({
  type: FETCH_JUSTIFICATION_DEMARCATE_LIST_REQUEST,
})

export const fetchJustificationDemarcateListSuccess = (data) => ({
  type: FETCH_JUSTIFICATION_DEMARCATE_LIST_SUCCESS,
  payload: data,
})

export const fetchJustificationDemarcateListError = (error) => ({
  type: FETCH_JUSTIFICATION_DEMARCATE_LIST_ERROR,
  payload: error,
})

export const updateJustificationDemarcate = (token, values) => (dispatch) => {
  dispatch(updateJustificationDemarcateRequest())

  const fields = {
    ...values,
  }

  return new Api(token, dispatch)
    .post(API_URL.SAVE_JUSTIFICATION_DEMARCATE, fields)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(updateJustificationDemarcateSuccess(response.data))
      dispatch(fetchJustificationDemarcateList(token))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(updateJustificationDemarcateError(error))
      dispatch(hideSpinner())
    })
}

export const updateJustificationDemarcateRequest = () => ({
  type: UPDATE_JUSTIFICATION_DEMARCATE_REQUEST,
})

export const updateJustificationDemarcateSuccess = (data) => ({
  type: UPDATE_JUSTIFICATION_DEMARCATE_SUCCESS,
  payload: data,
})

export const updateJustificationDemarcateError = (error) => ({
  type: UPDATE_JUSTIFICATION_DEMARCATE_ERROR,
  payload: error,
})

export const removeJustificationDemarcate = (token, id) => (dispatch) =>
  new Api(token, dispatch)
    .post(API_URL.REMOVE_JUSTIFICATION_DEMARCATE, id)
    .then(dispatch(showSpinner()))
    .then(() => {
      dispatch(fetchJustificationDemarcateList(token))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(updateJustificationDemarcateError(error))
      dispatch(hideSpinner())
    })
